import { motion } from "framer-motion";
import { Eyebrow } from "./Brand";

const VIDEOS = [
  { id: "corp-1", src: "/media/corp-1.mp4", poster: "/media/corp-1.jpg" },
  { id: "corp-2", src: "/media/corp-2.mp4", poster: "/media/corp-2.jpg" },
];

export const CorporateVideos = () => (
  <div data-testid="corporate-videos" className="mt-16 grid lg:grid-cols-12 gap-10 items-center">
    <div className="lg:col-span-4">
      <Eyebrow>Em ação</Eyebrow>
      <p className="mt-5 font-display font-black uppercase text-white text-2xl md:text-3xl leading-[1]">Eventos corporativos <span className="text-gold-grad">reais.</span></p>
      <p className="mt-4 text-zinc-300 text-base">Veja a Play Toys animando eventos de empresas.</p>
    </div>
    <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
      {VIDEOS.map((v, i) => (
        <motion.div key={v.id} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-[24px] overflow-hidden border border-white/10 bg-black aspect-[9/16] max-h-[640px] w-full mx-auto max-w-[360px] shadow-[0_30px_80px_-30px_rgba(255,210,0,0.35)]">
          <video data-testid={`corporate-video-${v.id}`} src={v.src} poster={v.poster} controls playsInline preload="metadata"
            className="absolute inset-0 w-full h-full object-cover" />
        </motion.div>
      ))}
    </div>
  </div>
);
